<template>
  <footer class="site-footer">
    <div
      v-if="route.path !== '/anfrage' && !route.path.startsWith('/admin')"
      class="footer-invite wrap"
    >
      <div>
        <h2>Lust auf ein <em>Projekt?</em></h2>
        <p>
          {{
            artPage
              ? 'Erzähl mir, was du zeichnen oder gestalten lassen möchtest.'
              : 'Ob Tattoo oder Gemälde – erzähl mir von deiner Idee.'
          }}
        </p>
      </div>
      <a
        v-if="artPage"
        href="mailto:rebecca.sophiaa.p@gmail.com?subject=Anfrage%20Auftragskunst"
        class="button button-light"
        >Auftrag anfragen <InkIcon name="diagonal"
      /></a>
      <router-link v-else to="/anfrage" class="button button-light"
        >Termin vereinbaren <InkIcon name="diagonal"
      /></router-link>
    </div>
    <div class="footer-main wrap">
      <div class="footer-brand">
        <router-link to="/">white pearl ink<span class="serif-star">✧</span></router-link>
        <p>
          Individuelle Tattoos und Seelenkunst in Kreuzlingen. Dein Safe Space für Kunst, die unter
          die Haut geht.
        </p>
      </div>
      <div class="footer-links">
        <span class="eyebrow">Menu</span><router-link to="/tattoos">Tattoos</router-link
        ><router-link to="/art">Kunstwerke</router-link
        ><router-link to="/tierportraets">Tierporträts nach Foto</router-link
        ><router-link to="/auftragskunst">Kunst nach Wunsch</router-link
        ><router-link to="/about-me">Über mich</router-link
        ><router-link to="/pets">Haustiere</router-link>
      </div>
      <div class="footer-links">
        <span class="eyebrow">Studio</span
        ><router-link to="/studio">Alleeweg 12<br />8280 Kreuzlingen</router-link>
        <p>Termine nach Vereinbarung.</p>
        <a
          href="https://www.instagram.com/whitepearl.ink/"
          target="_blank"
          rel="noopener noreferrer"
          class="social-link"
          ><InkIcon name="instagram" /> @whitepearl.ink</a
        ><a href="mailto:rebecca.sophiaa.p@gmail.com"
          >E-Mail schreiben <span aria-hidden="true">↗</span></a
        >
      </div>
    </div>
    <div class="footer-bottom wrap">
      <span>© {{ new Date().getFullYear() }} White Pearl Ink</span>
      <div>
        <router-link to="/impressum">Impressum</router-link
        ><router-link to="/datenschutz">Datenschutz</router-link
        ><button @click="scrollTop">Nach oben <InkIcon name="up" /></button>
      </div>
    </div>
  </footer>
</template>
<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import InkIcon from '@/components/ui/InkIcon.vue';
const route = useRoute();
const artPage = computed(() => ['/art', '/tierportraets', '/auftragskunst'].includes(route.path));
const scrollTop = () =>
  window.scrollTo({
    top: 0,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
  });
</script>
